<template>
  <nav class="mobile-pagination" aria-label="Pagination mobile">
    <button class="nav-btn" :disabled="page === 1" @click="emitChange(page - 1)">&lt;</button>
    <button v-for="p in pages" :key="`m-p-${p}`" :class="['page-btn', { active: p === page }]" @click="emitChange(p)">
      {{ p }}
    </button>
    <button class="nav-btn" :disabled="page === total" @click="emitChange(page + 1)">&gt;</button>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ page: number; total: number }>()
const emit = defineEmits<{ (e: 'change', value: number): void }>()

const emitChange = (value: number) => emit('change', value)

const pages = computed(() => {
  const total = props.total || 1
  const cur = props.page
  const arr: number[] = []
  if (cur - 1 >= 1) arr.push(cur - 1)
  arr.push(cur)
  if (cur + 1 <= total) arr.push(cur + 1)
  return arr
})
</script>

<style scoped lang="scss">
@import './mobile-pagination.scss';
</style>
